import {
  ECustomerAuthorizationEndpoints,
  customersAuthorizationApi
} from '../api';
import { EGerdauService } from '../EGerdauService';

export enum EHelpFileEndpoint {
  ORDERS = '/meus-pedidos',
  PURCHASE = '/comprar',
  INVOICES = '/minhas-financas',
  DASHBOARD = '/painel-gestao',
  ACCESS_MANAGEMENT = '/gestao-usuarios'
}

export class HelpMenuService extends EGerdauService {
  static async getHelpFile(endpoint: EHelpFileEndpoint): Promise<string> {
    const headers = new HelpMenuService().getHeaders();
    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.HELP_MENU}${endpoint}`,
      { headers }
    );

    return response.data as string;
  }
}
